import React from 'react';
import { connect } from 'react-redux';

import { Row, Col } from 'reactstrap';

import Application from '../Application';
import GeneralCalculationDesign from './components/GeneralCalculationDesign/GeneralCalculationDesign';
import MethodComponent from './components/Method';
import SafetyBarrierMethod from './components/SafetyBarrierMethod';
import Rebar from './components/Rebar';
import WoodConnectionDesign from './components/WoodConnectionDesign';
import { standardList, brandList } from './../../app.values';
import { BRAND } from '@config';
import { APP_TEXTS } from '@texts';

const Design = props => (
  <Row>
    <Col sm="12">
      {props.type === Application.types.GENERAL_CALCULATION && (
        <GeneralCalculationDesign appStatus={props.appStatus} designStd={props.designStd} />
      )}

      {props.type === Application.types.BRACKET_ATTACHMENT && (
        <MethodComponent appStatus={props.appStatus}/>
      )}

      {props.type === Application.types.SAFETY_BARRIER && (
        <SafetyBarrierMethod appStatus={props.appStatus}/>
      )}

      {props.type === Application.types.REBAR_REINFORCEMENT && (
        <Rebar />
      )}
      {props.type === Application.types.WOOD_CONNECTION && (
        <WoodConnectionDesign/>
      )}
    </Col>
  </Row>
);

export function getDesignMethodName(designStd) {
  switch (Number(designStd)){
    case standardList['ICC.Cast']:
    case standardList['ICC.Post']: {
      return APP_TEXTS.METHOD_ICC_NAME.Content;
    }
    case standardList['ANZ']: {
      return APP_TEXTS.METHOD_ANZ_NAME.Content;
    }
    case standardList['CSA']: {
      return APP_TEXTS.METHOD_CSA_NAME.Content;
    }
    case standardList['AS5216']: {
      return APP_TEXTS.METHOD_AS5216_NAME.Content;
    }
    case standardList['AnnexC']: {
      return APP_TEXTS.METHOD_ANNEXC_NAME.Content;
    }
    case standardList['EU']: 
    default: {
      return APP_TEXTS.METHOD_EUROPEAN_NAME.Content.replace("{0}", 
        BRAND === brandList.Ramset ? APP_TEXTS.METHOD_EUROPEAN_RAMSET.Content : APP_TEXTS.METHOD_EUROPEAN.Content);
    }
  }
}

const mapState = state => ({
  type: state.main.appType,
  appStatus: state.main.status,
  designStd: state.main.localization.designStandard
});

export default connect(mapState)(Design);



// WEBPACK FOOTER //
// ./src/views/Design/index.js